import React, { useState } from 'react';


import { ITextFieldStyles, ITextProps, ITextStyles, ITooltipHostStyles, mergeStyleSets, Text } from '@fluentui/react';
import { useId } from '@fluentui/react-hooks';


//const classNames = mergeStyleSets({
//    wrap: { position: 'relative' },
//    test: {
//        borderBottomColor: 'rgb(58, 59, 60)',
//        borderBottomLeftRadius: '10px',
//        borderBottomStyle: 'solid',
//        borderBottomWidth: '2px',
//        borderLeftColor: 'rgb(58, 59, 60)',
//        borderLeftStyle: 'solid',
//        borderLeftWidth: '2px',
//        borderRightColor: 'rgb(58, 59, 60)',
//        borderTopColor: 'rgb(58, 59, 60)',
//        color: 'rgb(28, 30, 33)',
//        direction: 'ltr',
//        display: 'block',
//        fontFamily: `"Segoe UI Historic", "Segoe UI", Helvetica, Arial, sans-serif`,
//        fontSize: '12px',
//        height: '20px',
//        lineHeight: '16.08px',
//        listStyleType: 'none',
//        position: 'absolute',
//        textAlign: 'left',
//        width: '24px',
//        bottom: '7px',

//        left: '-22px',

//    },
//    test2: {
//        backgroundColor: 'rgb(58, 59, 60)',
//        color: 'rgb(28, 30, 33)',
//        direction: 'ltr',
//        display: 'block',
//        fontFamily: `"Segoe UI Historic", "Segoe UI", Helvetica, Arial, sans-serif`,
//        fontSize: '12px',
//        height: '72px',
//        lineHeight: '16.08px',
//        listStyleType: 'none',
//        position: 'absolute',
//        textAlign: 'left',
//        width: '2px',
//        left: '-22px',
//    }
//});


const calloutProps = { gapSpace: 0 };
// The TooltipHost root uses display: inline by default.
// If that's causing sizing issues or tooltip positioning issues, try overriding to inline-block.
const hostStyles: Partial<ITooltipHostStyles> = { root: { display: 'inline-block' } };


export interface OrganigrammaNodeTemplateProps {
    uorNode,

}

const textStyles: Partial<ITextStyles> = {
    root: {
        color: 'inherit'
    }
}

const OrganigrammaNodeTemplate: React.FunctionComponent<OrganigrammaNodeTemplateProps> = (props) => {

    const tooltipId = useId('tooltip');

    const [isHovering, setIsHovering] = useState(false);

    const handleMouseHover = (ishovering) => {
        setIsHovering(ishovering);
    }

    return (

        <Text styles={textStyles}> {props.uorNode.label}</Text>
    )

    //return (
    //    <div className={classNames.wrap} >
    //        {props.uorNode.parentId &&
    //            <React.Fragment>
    //                <div className={classNames.test} ></div>
    //                {props.uorNode.children && props.uorNode.children.length > 0 &&
    //                    <div className={classNames.test2} ></div>
    //                }
    //            </React.Fragment>
    //        }
    //        <Text styles={textStyles}> {props.uorNode.label}</Text>
    //    </div>
    //)
}

export default OrganigrammaNodeTemplate;






